import { defineComponent as _defineComponent } from 'vue'

import { defineComponent, onMounted, useMeta } from "@nuxtjs/composition-api";

import { useAmplitude, useConfig, useMetaService, useTranslate } from "@/composables";
import { useCategoriesStore } from "@/store";
import { formatErrorMessage, handleErrorStatusCode } from "@/utils/api";
import { EXPERIMENTS_LOHP_VPM } from "@/utils/experiments/constants";
import logger, { logLevel } from "@/utils/logger";

const __default__ = defineComponent({
  name: "LoggedOutHomepage",
  asyncData: async ({ error }) => {
    // Fetch categories during SSR
    try {
      const categoriesStore = useCategoriesStore();
      await categoriesStore.getHashtags();
    } catch (err) {
      logger(logLevel.ERROR, "Error fetching likes", {}, err);
      error({
        statusCode: handleErrorStatusCode(err) ?? 0,
        message: `Error fetching likes - ${formatErrorMessage(err)}`,
      });
    }
  },
  head: {},
  meta: {
    showAppBadgeBanner: false,
  },
});

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const amplitude = useAmplitude();
const metaService = useMetaService();
const config = useConfig();
const { t } = useTranslate();

const title = t("LTK | Fashion, Home, Beauty, Fitness and More");
const description = t(
  "Shop the latest in fashion, home, beauty, fitness from LTK influencers you trust. Workwear ideas, wedding guest dresses, travel looks and so much more.",
);
const jsonLdScript = {
  type: "application/ld+json",
  json: {
    "@context": "http://schema.org/",
    "@type": "WebSite",
    name: "LTK",
    url: `https://${config.ltkHost}/`,
    publisher: {
      "@type": "Organization",
      name: "LTK",
      url: `https://${config.ltkHost}/`,
      logo: `https://${config.ltkHost}/icon.png`,
      sameAs: [
        "https://www.instagram.com/shop.ltk",
        "https://www.facebook.com/shop.ltk/",
        "https://twitter.com/shopltk",
        "https://www.linkedin.com/company/shopltk",
        "https://www.youtube.com/c/LIKEtoKNOWit_Shop_LTK",
      ],
    },
    description:
      "Shop thousands of products tried and styled by real people. Shop products across fashion, beauty, home, fitness and more. Tried and styled by real people for real life.",
    potentialAction: [
      {
        "@type": "SearchAction",
        target: {
          "@type": "Entrypoint",
          urlTemplate: `https://${config.ltkSite}/search?keyword={query}`,
        },
        "query-input": "required name=query",
      },
    ],
  },
};

// useMeta() needs reactive dependencies inside the invocation, or it's values will not be reactive
config.env === "prod"
  ? useMeta(() => ({
      ...metaService.setPageMeta({
        title: title.value,
        description: description.value,
        customTitle: true,
      }),
      script: [jsonLdScript],
    }))
  : useMeta(() => ({
      ...metaService.setPageMeta({
        title: title.value,
        description: description.value,
        customTitle: true,
        noIndex: true,
        noFollow: true,
      }),
      script: [jsonLdScript],
    }));

onMounted(() => {
  amplitude?.sendEvent("/page/lohp", { url: window.location.href });
});

return { __sfc: true,amplitude, metaService, config, t, title, description, jsonLdScript, EXPERIMENTS_LOHP_VPM }
}

})